<template>
	<div class="home">
		<div class="headers">
			<div class="left">
				<img v-if="appType == 'hc'" src="../../../assets/recharge/logo.png" alt="" />
				<img v-if="appType == 'ume'" src="../../../assets/recharge/ume_logo.png" alt="" />
			</div>
			<div class="right">
				<img :src="country" v-if="country" @click="changeSelect()" alt="" srcset="" />
				<span @click="changeSelect()">English</span>
				<img class="icon" :class="showSelect ? 'rota' : ''" @click="changeSelect()"
					src="../../../assets/recharge/bottom.png" alt="" />
				<div class="modules" @click="changeSelect()" v-if="showSelect">
					<div class="select">
						<div class="tab">
							<!-- <div class="l" :class="tab == 1 ? 'active' : ''">
									Language
								</div> -->
							<div class="r" :class="tab == 2 ? 'active' : ''">
								Country Region
							</div>
						</div>
						<div class="language" v-if="tab == 1">
							<div class="list">India</div>
							<div class="list">English</div>
						</div>
						<div class="Country">
							<div class="list_wrap">
								<div v-for="(item, index) in countryList" :key="index" class="list" @click.stop="changeCountry(item)"
									:class="countryType == item ? 'active' : ''">
									<span>{{ item.toUpperCase() }}</span>
									<img v-if="countryType == item" src="../../../assets/recharge/true_select.png" alt="" />
									<img v-else src="../../../assets/recharge/no_select.png" alt="" />
								</div>
							</div>
							<!-- <div class="list" @click.stop="changeCountry('in')" :class="countryType == 'in' ? 'active' : ''">
																<span>IN</span>
																<img v-if="countryType == 'in'" src="../../../assets/recharge/true_select.png" alt="" />
																<img v-else src="../../../assets/recharge/no_select.png" alt="" />
															</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 分界线 -->
		<div class="hrs" style="width: 1920px;height: 1px;background: #333333;margin-left: -280px;margin-top: 29px;"></div>

		<!-- 分左右 -->
		<van-row class="main">
			<van-col :span="12" class="left">
				<div class="tip">
					<img v-if="appType == 'hc'" src="../../../assets/recharge/banner.png" alt="" />
					<img v-if="appType == 'ume'" src="../../../assets/recharge/ume_banner.png" alt="" />
				</div>
				<div class="texts">
					<p>{{ appType == 'ume' ? 'UmeChat' : 'HoneyCam' }}</p>
					<p>
						{{ appType == "ume" ? 'UmeChat' : 'HoneyCam' }} is a 1v1 video call APP which can help you make
						friends from all of the world.
					</p>
					<img @click="goGoogle()" src="../../../assets/recharge/Google_web.png" alt="" srcset="" />
				</div>
				<div class="info" v-if="showWechat">
					<div class="t">
						<img src="../../../assets/recharge/gift.png" alt="">
						<span class="text">Add official {{ appType == "ume" ? 'Ume' : 'HC' }} team , get more discount & welfare &
							privilege</span>
					</div>
					<div class="b">
						<!-- <div class="list l">
													<div class="message">
														<div class="head">
															<img class="head_img" src="https://file.vidchatme.com/cover/ad199deaf624b26fe6b1c781ca1f8c33.jpg"
																alt="">
															<img class="head_wrap" src="../../../assets/recharge/head_wrap.png" alt="">
														</div>
														<div class="user_info">
															<div class="name">HCAdmin👑Jessica</div>
															<div class="country">
																<div class="icon"><img src="../../../assets/flags/lib_region_flag_vn.png" alt=""></div>
																<div class="test">Indonesia</div>
															</div>
														</div>
													</div>
													<div class="go_app"></div>
												</div> -->
						<div class="list r" @click="getWechat">
							<div class="message">
								<div class="head"></div>
								<div class="user_info">
									<div class="name">Whats app</div>
									<div class="country">
										<div class="test">+61 421 893 141(Australia)</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-col>
			<van-col :span="12" class="right_wrap">
				<div class="three-section">
					<div class="title">1.Fill in UID</div>
					<van-row class="section-main">
						<van-col :span="18" class="left">
							<van-field size="large" type="number" v-model="value"
								right-icon="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
								placeholder="Fill in UID" @click-right-icon="showExample()" class="inputs" maxlength="11"
								ref="inputs" />
						</van-col>
						<van-col :span="3" class="right" :class="appType == 'ume' ? 'ume_bg' : ''"
							style="height: 48px; line-height: 48px" @click="searchName()" ref="sameH">
							Submit
						</van-col>
						<div class="modules" @click="showsImg = false" v-if="showsImg">
							<img class="showsImg" src="../../../assets/recharge/show.png" alt="" srcset="" />
						</div>
					</van-row>
					<van-row class="tips" v-if="this.nickname != ''">
						<van-col> Nickname: {{ nickname }} </van-col>
					</van-row>
					<van-row class="tips" v-if="this.noId">
						<van-col>user does not exist</van-col>
					</van-row>
				</div>

				<div class="four-section">
					Click 'mine',the ID is next to your avatar Fill in your
					complete ID.For example:12345678
				</div>

				<div class="one-section" v-if="nickname && showPrize">
					<div class="title">2.Select a product</div>
					<van-row class="section-main">
						<van-col class="section-temp" span="7" v-for="(temp, key) in moneyArray" :key="key"
							@click="chooseMoney(temp.coin, key)">
							<div class="list" :class="{ actives: temp.active }">
								<div class="first" :class="appType == 'ume' ? 'ume_bg' : ''" v-if="temp.firstTime == 1">
									<div>First time</div>
									<!-- <div> +{{ temp.firstTimeRechargeSendCoin }}</div>
													<img src="../../../assets/recharge/zhuans.png" alt=""> -->
								</div>
								<div class="t">
									<img v-if="appType == 'hc'" src="../../../assets/recharge/money-icon.png" alt="" />
									<img v-if="appType == 'ume'" src="../../../assets/recharge/ume_money-icon.png" alt="" />

									<p>{{ temp.coin + temp.giveAmount }}</p>
									<div class="cheap" :class="appType == 'ume' ? 'ume_border' : ''" v-if="temp.discountRatio">
										<span v-if="temp.activeRecharge">+{{ temp.discountRatio }}</span>
										<span v-else>+{{ temp.discountRatio }}%</span>
									</div>
								</div>
								<div class="m" :class="appType == 'ume' ? 'ume_color' : ''" v-if="temp.giveAmount">
									{{ temp.coin }}
								</div>
								<div class="b">${{ temp.price }}</div>
								<img v-if="temp.active && appType == 'hc'" class="bg" src="../../../assets/recharge/select_bg.png"
									alt="" />
								<img v-if="temp.active && appType == 'ume'" class="bg" src="../../../assets/recharge/ume_select_bg.png"
									alt="" />
								<img class="avatarFrame" v-if="temp.avatarFrame" :src="temp.avatarFrame" alt="">
							</div>
						</van-col>

					</van-row>
					<div class="tips2">
						<p>First time reward is ONE id ONE CHANCE .</p>
						<p>link always gives more tokens than regular access.</p>
					</div>
				</div>
				<div class="two-section" v-if="nickname && showPrize && SelectType">
					<div class="title">3.Select the payment method</div>
					<van-row class="section-main Price_main">
						<van-col :class="appType == 'hc' ? 'section-temp-div ' : 'section-temp-div-ume'" span="11"
							v-for="(temp, key) in payChannelList" :key="key" @click="choosePrice(temp)">
							<div v-if="appType == 'hc'" :class="TypeSelect == temp ? 'actives' : ''">
								{{ isShowLine(temp) }}
							</div>
							<div v-if="appType == 'ume'" :class="TypeSelect == temp ? 'actives' : ''">
								{{ isShowLine(temp) }}
							</div>
						</van-col>
					</van-row>
				</div>
				<div class="two-section" v-if="nickname && showPrize && mymethods[0]">
					<div class="title">4.Choose the method of payment</div>
					<van-row class="section-main" v-if="countryType">
						<van-col class="section-temp" span="11" v-for="(temp, key) in mymethods" :key="key"
							@click="chooseMethods(temp.url, key)">
							<div v-if="appType == 'hc'" :class="{ actives: temp.active }">
								{{ temp.url }}
							</div>
							<div v-if="appType == 'ume'" class="ume_bg" :class="{ actives: temp.active }">
								{{ temp.url }}
							</div>
						</van-col>
					</van-row>
					<van-row class="no_select" v-else>
						Please select your region and recharge after selecting
						the region.
					</van-row>
				</div>
				<div class="three-section" v-if="showEmail && this.TypeSelect == '3'">
					<div class="title">5.Fill in Email</div>
					<van-row class="section-main">
						<van-col :span="18" class="left">
							<van-field size="large" type="text" v-model="formTemp.email" placeholder="Fill in Email" class="inputs" />
						</van-col>
					</van-row>
				</div>
				<van-row class="btn_wrap">
					<van-col class="left">
						<span> Amount: </span>
						<span style="color: #ff2794; font-weight: 600">{{ info.currency }}
							{{ info.localCurrencyAmount }}</span>
					</van-col>
					<van-col class="right">
						<button class="buyBtn" :class="appType == 'ume' ? 'ume_bg' : ''" v-if="isSelect" @click="goReCharge()">
							Top up immediately
						</button>
						<button class="buyBtn noSelect" :class="appType == 'ume' ? 'ume_bg' : ''" v-if="!isSelect"
							@click="goReCharge()">
							Top up immediately
						</button>
					</van-col>
				</van-row>
				<div class="select">
					<img src="../../../assets/recharge/no.png" @click="isSelect = !isSelect" v-if="!isSelect" alt="">
					<img src="../../../assets/recharge/yes.png" @click="isSelect = !isSelect" v-if="isSelect" alt="">
					<div>You agree to our <a :href="Privacy">《Privacy Policy》</a> and <a :href="Terms">《Terms of Conditions》</a>
					</div>
				</div>
			</van-col>
		</van-row>

		<van-overlay class="showGoogle" :show="showGoogle" @click="showGoogle = false">
			<div class="wrapper">
				<div class="block">
					<h1>{{ appType == "ume" ? 'UmeChat' : 'HoneyCam' }}</h1>
					<p>
						{{ appType == "ume" ? 'UmeChat' : 'HoneyCam' }} is a 1V1 video chat application that enables
						you to meet friends from all over the world.
					</p>
					<img @click="goGoogle()" src="../../../assets/recharge/Google.png" alt="" srcset="" />
				</div>
			</div>
		</van-overlay>
		<van-overlay class="showError" :show="showError" @click="showError = false">
			<div class="wrapper">
				<div class="block">
					<h1>
						<img src="../../../assets/recharge/error.png" alt="" />Cannot find user's ID
					</h1>
					<p>
						We don't search your ID:{{ this.value }} Please check
						again.
					</p>
					<button class="btn" @click="showError = false">OK</button>
				</div>
			</div>
		</van-overlay>
		<div class="footer">
			<div class="footer_top">
				<a :href="Terms">Terms of Conditions</a>
				<a :href="Privacy">Privacy Policy</a>
				<a :href="Refund">Refund Policy</a>
				<a>Contact us：{{ appType == 'hc' ? 'support@honeycamweb.com' : 'support@beautychatweb.com' }}</a>
			</div>
			<div class="bottom">
				<div class="l">Copyright©2023 Shanghai Shenwei Cyber Technology Center all rights reserved.</div>
				<img v-if="appType == 'hc'" src="../../../assets/recharge/right_icon.png" alt="">
				<img v-if="appType == 'ume'" src="../../../assets/recharge/ume_right_logo.png" alt="">
			</div>
		</div>
		<div class="model" v-if="modelShow">
			<div class="model_close" @click="modelShow = false"></div>
			<div class="form_wrap">
				<form id='place_order' method="post" ref="formval">
					<!--这些参数都是商户自己的提交参数-->
					<div>
						<input type="hidden" name="CUS_EMAIL" ref="input1" :value="formTemp.email" />
						<input type="hidden" name="BIL_PRICE" ref="input2" :value="formTemp.price" />
						<input type="hidden" name="BIL_CC3DS" ref="input3" :value="formTemp.cc3ds" />
						<input type="hidden" name="BIL_CURRENCY" ref="input4" :value="formTemp.currency" />
						<input type="hidden" name="BIL_GOODSNAME" ref="input5" :value="formTemp.goodsname" />
						<input type="hidden" name="CUS_COUNTRY" ref="input6" :value="formTemp.country" />
					</div>

					<!-- 指定表单要插入的位置 -->
					<div id="testFrom"></div>

					<!-- <div style="max-width:400px;margin :0 auto;text-align:center">
						<input style="padding: 5px 10px;cursor: pointer;width:100px" id="sub_order" type="button" value="付款" />
					</div> -->
					<div class="btns" @click="getGlcash" :class="appType == 'ume' ? 'ume_bg' : ''">
						<img v-if="loading" src="../../../assets/recharge/loading.png" alt="">
						submit
					</div>
				</form>
			</div>
		</div>
		<van-overlay class="showCheckout" :show="showCheckoutPop">
			<div class="wrapper">
				<div class="block">
					<div class="close-checkout">
						<van-icon name="cross" @click="showCheckoutPop = false" />
					</div>
					<div class="show-checkout-pop">
						<form id="payment-form" method="POST" action="https://merchant.com/charge-card">
							<div class="one-liner">
								<div class="card-frame"></div>
								<button id="pay-button" disabled @click="handlePayButtonClick">
									<span v-if="!disabledLoading">ok</span>
									<span v-else>Loading...</span>
								</button>
							</div>
							<p class="error-message"></p>
						</form>
					</div>
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import { getPrize, getCurrentId, payerMaxCreate, SendAjax } from '../api/act_task'
import { Toast, Dialog } from 'vant'
import 'vant/es/dialog/style'
import { AddressParameter } from '../../../utils/index'
import "./glcash"
import payType from './type'
export default {
	name: 'home',
	data () {
		return {
			screenWidth: null,
			screenHeight: null,
			colorDepth: null,
			timestamp: null,
			payChannelListSwitchLine1: null,
			showGoogle: false, // 更多信息弹框
			showError: false, // 用户id不存在弹框
			showsImg: false, // 显示示例
			showCheckoutPop: false, //是否展示checkout支付方式
			CheckoutTokenInfo: null, //获取卡号信息的token
			disabledLoading: false, //loading
			taskList: [],
			modelShow: false,
			appId: null, // glcash appID
			userId: '',
			showEmail: false,
			CoinPrice: null,
			loading: false,
			formTemp: {
				email: "",
				price: "",
				cc3ds: 1, // 0 不开启 1 不开启
				currency: "", // 货币
				goodsname: "",
				country: "",
			},
			countryType: '',
			oldCountry: '',
			glocash: '',
			payerMax: '',
			noId: false,
			userNumber: '',
			showPrize: false,
			TypeSelect: '',
			isSelect: true,
			payChannelList: [],
			showWechat: false,
			appType: "hc",
			tab: 2,
			language: '',
			SelectType: null,
			queryId: '',
			showSelect: false,
			isGlcash: false,
			isCanClick: true,
			Terms: "",
			Privacy: "",
			Refund: "",
			lang: localStorage.getItem('lang') || 'en',
			moneyArray: [
				{
					prize: '111',
					active: true,
				},
			],
			mymethods: [],
			value: '',
			countryList: [],
			country: null,
			noSelectCountry: false,
			nickname: '',
			info: {
				prize: '', //价格
				prizeId: '', //价格ID
				paymentType: '', // 支付方式
				currency: '', // 货币类型
			},
		}
	},
	mounted () {
		this.screenWidth = window.screen.width;
		this.screenHeight = window.screen.height;
		this.colorDepth = window.screen.colorDepth;
		this.timestamp = new Date().getTime();
		setTimeout(() => {
			this.$refs.sameH.$el.style.height = `${this.$refs.inputs.height}px`
			this.$refs.sameH.$el.style.lineHeight =
				this.$refs.sameH.$el.style.height
		}, 20)
		// 监听点击事件
		const script = document.createElement("script");
		script.src = "https://cdn.checkout.com/js/framesv2.min.js";
		script.onload = () => {
			// 在组件挂载后执行初始化和事件处理
			/* global Frames */
			var payButton = document.getElementById("pay-button");
			var form = document.getElementById("payment-form");
			var errorStack = [];
			var expectedEventsCount = 1; // 期望的事件数量，这里是 CARD_TOKENIZED 事件，如果有其他事件也需要处理，请相应增加这个数量
			var completedEventsCount = 0; // 已完成的事件数量
			if (process.env.VUE_APP_ENV == "production") {
				Frames.init("pk_pjd456rlya7rt5z4u3uosb6llqo");
			} else {
				Frames.init("pk_sbox_lc373ldfaonxi5hvdbpizhhoumm");
			}

			Frames.addEventHandler(
				Frames.Events.CARD_VALIDATION_CHANGED,
				onCardValidationChanged
			);
			function onCardValidationChanged (event) {
				payButton.disabled = !Frames.isCardValid();
			}

			Frames.addEventHandler(
				Frames.Events.FRAME_VALIDATION_CHANGED,
				onValidationChanged
			);
			function onValidationChanged (event) {
				var errorMessageElement = document.querySelector(".error-message");
				var hasError = !event.isValid && !event.isEmpty;

				if (hasError) {
					errorStack.push(event.element);
				} else {
					errorStack = errorStack.filter(function (element) {
						return element !== event.element;
					});
				}

				var errorMessage = errorStack.length
					? getErrorMessage(errorStack[errorStack.length - 1])
					: "";
				errorMessageElement.textContent = errorMessage;
			}

			function getErrorMessage (element) {
				var errors = {
					"card-number": "Please enter a valid card number",
					"expiry-date": "Please enter a valid expiry date",
					cvv: "Please enter a valid cvv code",
				};

				return errors[element];
			}

			Frames.addEventHandler(
				Frames.Events.CARD_TOKENIZATION_FAILED,
				onCardTokenizationFailed
			);
			function onCardTokenizationFailed (error) {
				Frames.enableSubmitForm();
			}

			Frames.addEventHandler(Frames.Events.CARD_TOKENIZED, (event) => {
				this.CheckoutTokenInfo = event.token;
				// 在事件成功的情况下，触发已完成的事件数量
				completedEventsCount++;
				checkAllEventsCompleted();
			});

			form.addEventListener("submit", function (event) {
				event.preventDefault();
				Frames.submitCard();
			});

			function checkAllEventsCompleted () {
				// 当所有事件都完成时，执行接口走完之后的操作
				if (completedEventsCount === expectedEventsCount) {
					// 在这里执行所有接口走完之后的操作
					this.showCheckoutPop = false; // 这里是隐藏弹窗的操作
					this.disabledLoading = false;
					this.goReCharge(this.CheckoutTokenInfo, null);
				}
			}
			checkAllEventsCompleted = checkAllEventsCompleted.bind(this);
		};
		document.head.appendChild(script);
	},
	components: {
		[Dialog.Component.name]: Dialog.Component,
	},
	created () {
		if (window.location.href.includes("/ume")) {
			localStorage.setItem("appType", "UmeChat");
			this.appType = "ume"
			if (process.env.VUE_APP_ENV == 'production') {
				this.Terms = 'https://static.vidchatme.com/app/UmeRechargeTerm.html'
				this.Privacy = 'https://static.vidchatme.com/app/UmeRechargePrivicys.html'
				this.Refund = "https://static.vidchatme.com/app/UmeRechargeRefund.html"
			} else {
				this.Terms = 'http://52.221.156.209/webcli/UmeRechargeTerm.html'
				this.Privacy = 'http://52.221.156.209/webcli/UmeRechargePrivicys.html'
				this.Refund = "http://52.221.156.209/webcli/UmeRechargeRefund.html"
			}
		} else {
			this.appType = "hc"
			if (process.env.VUE_APP_ENV == 'production') {
				this.Terms = 'https://static.vidchatme.com/app/RechargeTerm.html'
				this.Privacy = 'https://static.vidchatme.com/app/RechargePrivicys.html'
				this.Refund = "https://static.vidchatme.com/app/RechargeRefund.html"
			} else {
				this.Terms = 'http://52.221.156.209/webcli/RechargeTerm.html'
				this.Privacy = 'http://52.221.156.209/webcli/RechargePrivicys.html'
				this.Refund = "http://52.221.156.209/webcli/RechargeRefund.html"
			}
		}
		for (let i in payType) {
			this.countryList.push(i)
		}
		// 获取国家选项
		var p = navigator.platform
		var system = {
			win: false,
			mac: false,
			xll: false,
			ipad: false,
		}
		system.win = p.indexOf('Win') == 0
		system.mac = p.indexOf('Mac') == 0
		this.value = AddressParameter('userId')
		if (AddressParameter('userId')) {
			this.searchName()
		}
		system.x11 = p == 'X11' || p.indexOf('Linux') == 0
		system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false
		if (system.win || system.mac || system.xll || system.ipad) {
		} else {
			if (process.env.VUE_APP_ENV == 'production') {
				if (this.appType == 'hc') {
					location.href =
						'https://static.vidchatme.com/act/recharge.html?sign=' +
						AddressParameter('sign')
				} else if (this.appType == 'ume') {
					location.href =
						'https://static.vidchatme.com/recharge/ume/h5/recharge.html?sign=' +
						AddressParameter('sign')
				}
				// location.href =
				// 	'https://static.vidchatme.com/recharge/h5/recharge.html?sign=' +
				// 	AddressParameter('sign')
			} else {
				if (this.appType == 'hc') {
					location.href =
						'http://52.221.156.209/act/recharge.html?sign=' +
						AddressParameter('sign')
				} else if (this.appType == 'ume') {
					location.href =
						'http://52.221.156.209/recharge/ume/h5/recharge.html?sign=' +
						AddressParameter('sign')
				}
			}
		}
		this.countryType = 'other'
		this.mymethods = []
		this.country = require('../../../assets/flags/lib_region_flag_other.png')
		// 支付方式初始化
		// this.info.paymentType = this.mymethods[0].remark
	},
	beforeDestroy () {
		// 在页面关闭之前执行清除操作
		window.addEventListener("beforeunload", this.cleanupLocalStorage);
	},
	methods: {
		cleanupLocalStorage () {
			// 清除 localStorage 中的值
			localStorage.removeItem("appType");
		},
		handlePayButtonClick () {
			this.disabledLoading = true;
		},
		isShowLine (temp) {
			if (temp == "1") {
				return "Line2";
			} else if (temp == "5") {
				return "Line4";
			} else if (temp == "4") {
				return "Line3";
			} else {
				return "Line1";
			}
		},
		choosePrice (index) {
			let price = null
			for (let i = 0; i < this.moneyArray.length; i++) {
				if (this.moneyArray[i].active) {
					price = this.moneyArray[i].price
				}
			}
			if (index == '1') {
				if (this.TypeSelect == '1') {
					return
				}
				this.moneyArray = this.CoinPrice['PayerMax']
				this.TypeSelect = '1'
				this.priceType = price
				for (let i = 0; i < this.moneyArray.length; i++) {
					if (this.priceType == this.moneyArray[i].price) {
						for (let j = 0; j < this.moneyArray.length; j++) {
							this.moneyArray[j].isDefault = 0
						}
						this.moneyArray[i].isDefault = 1
					}
				}
				SendAjax({
					type: 100015,
					bannerId: this.bannerId,
					userId: this.userId
				})
			} else if (index == "3") {
				if (this.TypeSelect == '3') {
					return
				}
				// 暂时隐藏lin1
				if (!this.payChannelListSwitchLine1) {
					this.moneyArray = this.CoinPrice['glocash']
					this.TypeSelect = '3'
					this.priceType = price
					for (let i = 0; i < this.moneyArray.length; i++) {
						if (this.priceType == this.moneyArray[i].price) {
							for (let j = 0; j < this.moneyArray.length; j++) {
								this.moneyArray[j].isDefault = 0
							}
							this.moneyArray[i].isDefault = 1
						}
					}
					SendAjax({
						type: 100014,
						bannerId: this.bannerId,
						userId: this.userId
					})
				}
				return Toast("Channel under maintenance");
			} else if (index == "4") {
				if (this.TypeSelect == "4") {
					return;
				}
				this.moneyArray = this.CoinPrice["pingpong"];
				this.TypeSelect = "4";
				this.priceType = price;
				for (let i = 0; i < this.moneyArray.length; i++) {
					if (this.priceType == this.moneyArray[i].price) {
						for (let j = 0; j < this.moneyArray.length; j++) {
							this.moneyArray[j].isDefault = 0;
						}
						this.moneyArray[i].isDefault = 1;
					}
				}
			} else if (index == "5") {
				if (this.TypeSelect == "5") {
					return;
				}
				this.fourthPointPayment = true;
				this.fifthPointPayment = false;
				this.moneyArray = this.CoinPrice["checkout"];
				this.TypeSelect = "5";
				this.priceType = price;
				for (let i = 0; i < this.moneyArray.length; i++) {
					if (this.priceType == this.moneyArray[i].price) {
						for (let j = 0; j < this.moneyArray.length; j++) {
							this.moneyArray[j].isDefault = 0;
						}
						this.moneyArray[i].isDefault = 1;
					}
				}
			}
			this.moneyArray.forEach((element, index) => {
				element.active = false
				if (element.isDefault == 1) {
					element.active = true
					this.info.prize = element.price
					this.info.prizeId = element.priceId
					this.info.localCurrencyAmount =
						element.localCurrencyAmount
					this.info.currency = element.currency
					this.formTemp.price = element.price
					this.formTemp.currency = element.currency
					if (element.giveAmount) {
						this.formTemp.goodsname = (element.giveAmount + element.coin) + ' token'
					} else {
						this.formTemp.goodsname = element.coin + ' token'
					}
				}
			})
		},
		getWechat () {
			window.location.href = "https://api.whatsapp.com/send?phone=85267451963"
		},
		showModelFunc () {
			if (this.modelShow) {
				return
			}
			this.modelShow = true
			// 初始化支付插件
			let glcashConfig = {
				appId: this.appId, //商户ID 必填
				payElement: "testFrom",//需要放入的支付表单的位置
				isToken: true, // token支付 必须是true
				buyerId: this.value, // 买家ID
				config: {
					"card_iframe": { "style": "border: none; width: 100%;height:300px;display:none" },
				} // 设置iframe样式
			}
			setTimeout(() => {
				glocashPay.init(glcashConfig)
			}, 100)
		},
		getGlcash () {
			if (!this.isCanClick) {
				return
			}
			this.isCanClick = false;
			let that = this
			this.loading = true
			glocashPay.checkout(function ({ data }) {
				if (data.error) {
					console.error("创建卡信息失败:" + data.error);
					that.isCanClick = true
					that.loading = false
					return false;
				}
				var postData = [];
				// glocash input框长度
				for (let i = 0; i < 6; i++) {
					postData.push({
						name: that.$refs['input' + [i + 1]].name,
						value: that.$refs['input' + [i + 1]].value
					})
				}
				if (data.token) {
					postData.push({ name: 'BIL_TEMP_TOKEN', value: data.token });
				}
				if (data.bilToken) {
					postData.push({ name: 'BIL_TOKEN', value: data.bilToken });
				}
				let token = {
					bilTempToken: data.token,
					bilToken: data.bilToken
				}
				that.goReCharge(postData, token)
			});
		},
		changeSelect () {
			this.showSelect = !this.showSelect
			if (this.showSelect) {
				this.showsImg = false
			}
		},
		changeCountry (val) {
			this.countryType = val
			setTimeout(() => {
				this.showSelect = false
			}, 500)
			this.country = require('../../../assets/flags/lib_region_flag_' +
				val +
				'.png')
			if (this.noSelectCountry == false && this.value) {
				this.noSelectCountry = true
				this.changeCountryList()
			}
			this.noSelectCountry = true
			if (this.nickname && this.showPrize) {
				this.changeCountryList()
			}
		},
		goReCharge (val, token) {
			if (!this.isSelect) {
				Toast("Please agree to 《Privacy Policy》 and 《Terms of Conditions》")
				this.isCanClick = true
				this.loading = false
				return
			}
			if (!this.CheckoutTokenInfo && this.TypeSelect == "5") {
				this.showCheckoutPop = true;
				return;
			}
			if (!/^[0-9]*$/.test(this.value)) {
				this.isCanClick = true
				Toast('Format error')
				this.loading = false
				return
			}
			if (this.TypeSelect == "3") {
				// if (this.TypeSelect == '3' || this.TypeSelect == "4") {
				if (this.isGlcash) {
					if (!this.formTemp.email) {
						this.isCanClick = true
						Toast("Please enter your Email")
						this.loading = false
						return
					}
					if (!this.payChannelListSwitchLine1) {
						if (!val) {
							this.isCanClick = true
							this.showModelFunc()
							this.loading = false
							return
						}
					}
				}
			}
			if (this.value && this.value != '' && this.nickname != '') {
				var infos = {}
				infos.priceId = this.info.prizeId
				if (this.TypeSelect == '3' && !this.payChannelListSwitchLine1) {
					infos.channelType = '8'
					infos.paymentType = this.info.paymentType
				} else if (this.TypeSelect == '1') {
					infos.channelType = '4'
				}
				//新增 pingpong 支付方式
				else if (this.TypeSelect == "4") {
					infos.channelType = "10";
					infos.screenWidth = this.screenWidth;
					infos.screenHeight = this.screenHeight;
					infos.colorDepth = this.colorDepth;
					infos.timestamp = this.timestamp;
				}
				//新增 check out 支付方式
				else if (this.TypeSelect == "5") {
					infos.channelType = "11";
					infos.checkoutToken = this.CheckoutTokenInfo;
				}
				infos.paymentType = "A34";
				infos.userNumber = this.queryId
				infos.country = this.oldCountry.toUpperCase()
				infos.sign = AddressParameter('sign')
				infos.mobileBrowser = 0
				// 邮箱暂时不开发
				// if (this.TypeSelect == '3' || this.TypeSelect == "4") {
				if (this.TypeSelect == "3") {
					if (this.formTemp.email) {
						infos.email = this.formTemp.email
					}
					if (!this.payChannelListSwitchLine1) {
						if (token.bilTempToken) {
							infos.bilTempToken = token.bilTempToken
						}
						if (token.bilToken) {
							infos.bilToken = token.bilToken
						}
					}
				}
				payerMaxCreate(infos)
					.then((res) => {
						if (res.data.result.hasError) {
							Toast(res.data.result.errMessage)
							this.isCanClick = true
							this.loading = false
						} else {
							this.isCanClick = true
							// 跳转三方界面
							this.isGlcash = false;
							this.loading = false
							window.location.href = res.data.result.requestUrl
						}
					})
					.catch((err) => {
						this.isCanClick = true
						this.loading = false
						if (err.errorCode == '1000002') {
							Toast('Illegal request')
						}
						if (err.errorCode == '1000190') {
							Dialog.alert({
								message: this.$t('task.noRecharge'),
								confirmButtonText: this.$t('task.query'),
							})
						}
						// if(err.errorCode == '1000002')
						console.log(err)
					})
			} else if (this.nickname == '') {
				Toast('Please to view your nickname')
				this.loading = false
				this.isCanClick = true
			} else {
				this.isCanClick = true
				this.loading = false
				Toast('Fill in ID')
			}
		},
		searchName () {
			if (this.countryType && this.queryId) {
				var newHref = window.location.origin + window.location.pathname
				if (AddressParameter('sign')) {
					newHref =
						newHref +
						'?sign=' +
						AddressParameter('sign') +
						'&userId=' +
						this.value
				} else {
					newHref = newHref + '?userId=' + this.value
				}
				window.location.href = newHref
			}
			if (!/^[0-9]*$/.test(this.value)) {
				Toast('Format error')
				return
			}
			if (this.value && this.value != '') {
				getPrize({
					userNumber: this.value,
					country: this.countryType.toUpperCase(),
					userSelect: this.noSelectCountry ? 1 : 0,
				})
					.then((res) => {
						this.CoinPrice = {}
						this.userId = res.data.result.userId
						this.TypeSelect = res.data.result.defaultChannelType
						this.payChannelList = res.data.result.payChannelList
						this.payChannelListSwitchLine1 = res.data.result.payChannelList.includes("3");
						if (res.data.result.partyChannelMap['1']) {
							this.CoinPrice['PayerMax'] = res.data.result.partyChannelMap['1'].userCoinRechargeH5PriceVos
						}
						if (res.data.result.partyChannelMap['3']) {
							this.CoinPrice['glocash'] = res.data.result.partyChannelMap['3'].userCoinRechargeH5PriceVos
						}
						if (res.data.result.partyChannelMap["4"]) {
							this.CoinPrice["pingpong"] = res.data.result.partyChannelMap["4"].userCoinRechargeH5PriceVos;
						}
						if (res.data.result.partyChannelMap["5"]) {
							this.CoinPrice["checkout"] = res.data.result.partyChannelMap["5"].userCoinRechargeH5PriceVos;
						}
						this.SelectType = res.data.result.partyChannelMap
						if (res.data.result.partyChannelMap['3'].glocashPayAppId) {
							this.appId = res.data.result.partyChannelMap['3'].glocashPayAppId
						}
						if (res.data.result.showBanner) {
							this.showWechat = true
						} else {
							this.showWechat = false
						}
						if (res.data.result.country) {
							if (
								!this.countryList.includes(
									res.data.result.country.toLowerCase()
								)
							) {
								this.showSelect = true
								return
							}
							this.changeCountry(
								res.data.result.country.toLowerCase()
							)
						} else {
							if (!this.noSelectCountry) {
								this.showSelect = true
								return
							}
						}
						if (payType[this.countryType][0]) {
							this.mymethods = payType[this.countryType]
							this.chooseMethods(this.mymethods[0].url)
							if (this.mymethods[0].isGlcash) {
								this.showEmail = true
								this.isGlcash = true
							}
						} else {
							this.info.paymentType = ''
							this.mymethods = []
							this.isGlcash = false
						}
						this.queryId = this.value
						if (this.TypeSelect == 1) {
							this.moneyArray = this.CoinPrice['PayerMax']
						}
						if (this.TypeSelect == 3) {
							this.moneyArray = this.CoinPrice['glocash']
						}
						if (this.TypeSelect == 4) {
							this.moneyArray = this.CoinPrice["pingpong"];
						}
						if (this.TypeSelect == 5) {
							this.moneyArray = this.CoinPrice["checkout"];
						}
						this.showPrize = true
						this.oldCountry = this.countryType
						this.nickname = res.data.result.nickName
						this.formTemp.email = res.data.result.email
						this.noId = false
						this.moneyArray.forEach((element, index) => {
							element.active = false
							if (element.isDefault == 1) {
								element.active = true
								this.info.prize = element.price
								this.info.prizeId = element.priceId
								this.info.localCurrencyAmount =
									element.localCurrencyAmount
								this.info.currency = element.currency
								this.formTemp.price = element.price
								this.formTemp.currency = element.currency
								if (element.giveAmount) {
									this.formTemp.goodsname = (element.giveAmount + element.coin) + ' token'
								} else {
									this.formTemp.goodsname = element.coin + ' token'
								}
								this.formTemp.country = res.data.result.country
							}
						})
						SendAjax({
							type: 100013,
							bannerId: this.bannerId,
							userId: this.userId
						})
					})
					.catch((err) => {
						if (err.errorCode == '1000002') {
							Toast('Illegal request')
						}
						if (err.errorCode == '1000147') {
							this.noId = true
						}
						console.log(err)
					})
			} else {
				Toast('Fill in ID!')
			}
		},
		changeCountryList () {
			if (!/^[0-9]*$/.test(this.value)) {
				Toast('Format error')
				return
			}
			if (this.value && this.value != '') {
				getPrize({
					userNumber: this.value,
					country: this.countryType.toUpperCase(),
					userSelect: this.noSelectCountry ? 1 : 0,
				})
					.then((res) => {
						this.CoinPrice = {}
						this.userId = res.data.result.userId
						this.TypeSelect = res.data.result.defaultChannelType
						this.payChannelList = res.data.result.payChannelList
						this.payChannelListSwitchLine1 = res.data.result.payChannelList.includes("3");
						if (res.data.result.partyChannelMap['1']) {
							this.CoinPrice['PayerMax'] = res.data.result.partyChannelMap['1'].userCoinRechargeH5PriceVos
						} else if (res.data.result.partyChannelMap['3']) {
						}
						if (res.data.result.partyChannelMap['3']) {
							this.CoinPrice['glocash'] = res.data.result.partyChannelMap['3'].userCoinRechargeH5PriceVos
						}
						if (res.data.result.partyChannelMap["4"]) {
							this.CoinPrice["pingpong"] =
								res.data.result.partyChannelMap["4"].userCoinRechargeH5PriceVos;
						}
						if (res.data.result.partyChannelMap["5"]) {
							this.CoinPrice["checkout"] =
								res.data.result.partyChannelMap["5"].userCoinRechargeH5PriceVos;
						}
						this.SelectType = res.data.result.partyChannelMap
						if (res.data.result.showBanner) {
							this.showWechat = true
						} else {
							this.showWechat = false
						}
						if (res.data.result.partyChannelMap['3'].glocashPayAppId) {
							this.appId = res.data.result.partyChannelMap['3'].glocashPayAppId
						}
						if (payType[this.countryType][0]) {
							this.mymethods = payType[this.countryType]
							this.chooseMethods(this.mymethods[0].url)
							if (this.mymethods[0].isGlcash) {
								this.showEmail = true
								this.isGlcash = true
							}
						} else {
							this.info.paymentType = ''
							this.mymethods = []
							this.isGlcash = false
						}
						this.queryId = this.value
						if (this.TypeSelect == 1) {
							this.moneyArray = this.CoinPrice['PayerMax']
						}
						if (this.TypeSelect == 3) {
							this.moneyArray = this.CoinPrice['glocash']
						}
						if (this.TypeSelect == 4) {
							this.moneyArray = this.CoinPrice["pingpong"];
						}
						if (this.TypeSelect == 5) {
							this.moneyArray = this.CoinPrice["checkout"];
						}
						this.showPrize = true
						this.oldCountry = this.countryType
						this.nickname = res.data.result.nickName
						this.formTemp.email = res.data.result.email
						this.noId = false
						this.moneyArray.forEach((element, index) => {
							element.active = false
							if (element.isDefault == 1) {
								element.active = true
								this.info.prize = element.price
								this.info.prizeId = element.priceId
								this.info.localCurrencyAmount =
									element.localCurrencyAmount
								this.info.currency = element.currency
								this.formTemp.price = element.price
								this.formTemp.currency = element.currency
								if (element.giveAmount) {
									this.formTemp.goodsname = (element.giveAmount + element.coin) + ' token'
								} else {
									this.formTemp.goodsname = element.coin + ' token'
								}
								this.formTemp.country = res.data.result.country
							}
						})
					})
					.catch((err) => {
						if (err.errorCode == '1000002') {
							Toast('Illegal request')
						}
						if (err.errorCode == '1000147') {
							this.noId = true
						}
						console.log(err)
					})
			} else {
				Toast('Fill in ID!')
			}
		},
		routerLink (item) {
			this.$router.push(item.router)
		},
		showExample () {
			// 展示例子
			this.showsImg = !this.showsImg
			if (this.showsImg) {
				this.showSelect = false
			}
		},
		chooseMoney (prize, val) {
			// 切换价格选择
			var newArr = []
			this.moneyArray.forEach((element) => {
				if (element.coin == prize) {
					element.active = true
					this.info.prize = element.price
					this.info.prizeId = element.priceId
					this.info.localCurrencyAmount = element.localCurrencyAmount
					this.formTemp.price = element.price
					this.formTemp.currency = element.currency
					if (element.giveAmount) {
						this.formTemp.goodsname = (element.giveAmount + element.coin) + ' token'
					} else {
						this.formTemp.goodsname = element.coin + ' token'
					}
					this.formTemp.country = this.countryType
				} else {
					element.active = false
				}
				newArr.push(element)
			})
			this.moneyArray = newArr
		},
		chooseMethods (url, val) {
			// 切换方式选择
			this.mymethods.forEach((element) => {
				if (element.url == url) {
					element.active = true
					this.info.paymentType = element.remark
					if (element.isGlcash) {
						this.isGlcash = true
					} else {
						this.isGlcash = false
					}
				} else {
					element.active = false
				}
			})
		},
		showMoreInformation () {
			this.showGoogle = true
		},
		goGoogle () {
			if (this.appType == 'hc') {
				window.location.href = 'https://play.google.com/store/apps/details?id=com.honeycam'
			} else if (this.appType == 'ume') {
				window.location.href = "https://play.google.com/store/apps/details?id=com.umechat"
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@field-icon-size: 20px #app {
	background-size: 100% 100%;
	width: 100%;
	height: 100%;
	// overflow: hidden;
	-webkit-overflow-scrolling: touch;
}

.home {
	width: 1920px;
	min-height: 100vh;
	background: #251b3a;
	color: #ffffff;
	padding: 0 260px 200px 260px;
	position: relative;

	.headers {
		width: 1400px;
		height: 60px;
		padding-top: 30px;

		.left {
			float: left;

			img {
				width: 183px;
			}
		}

		.right {
			float: right;
			line-height: 60px;
			position: relative;

			.rota {
				transform: rotate(180deg);
			}

			img {
				width: 36px;
				height: 36px;
				border-radius: 50%;
				overflow: hidden;
				transform: translateY(25%);
				margin-right: 10px;
			}

			span {
				vertical-align: middle;
			}

			.icon {
				transition: 0.3s;
				width: 20px;
				height: 20px;
				margin-left: 8px;
			}

			.modules {
				position: fixed;
				left: 0;
				top: 0;
				width: 100vw;
				height: 100vh;
				z-index: 999;

				.select {
					width: 232px;
					position: absolute;
					right: 240px;
					top: 5.125vw;
					background: white;
					z-index: 999;
					color: #333333;

					.tab {
						display: flex;
						justify-content: space-between;

						div {
							width: 100%;
							text-align: center;
							line-height: 64px;
						}

						.active {
							background: linear-gradient(134deg,
									#f99634 0%,
									#ff2794 100%);
							color: white;
						}
					}

					.language {
						.list {
							width: 100%;
							height: 60px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							padding: 0 32px;
						}
					}

					.Country {
						.list_wrap {
							height: 600px;
							overflow-y: scroll;
						}

						.list {
							width: 100%;
							height: 60px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							padding: 0 10px 0 20px;
							position: relative;

							img {
								width: 16px;
								height: 16px;
							}
						}

						.active {
							background: linear-gradient(134deg,
									rgba(249, 150, 52, 0.2) 0%,
									rgba(255, 39, 148, 0.2) 100%);
						}
					}
				}
			}
		}
	}

	.main {
		margin-top: 40px;

		.left {

			// background: red;
			.info {
				text-align: left;
				float: left;
				width: 90%;
				background: url('../../../assets/recharge/model_bg.png') no-repeat;
				background-size: 100%;
				margin-top: 168px;
				margin-bottom: 40px;
				padding: 24px 20px 25px 24px;

				.t {
					display: flex;
					align-items: center;

					img {
						width: 60px;
						height: 60px;
					}

					.text {
						margin-left: 12px;
						font-size: 20px;
					}
				}

				.b {
					display: flex;
					align-items: center;
					margin-top: 43px;
					justify-content: space-between;

					.list {
						width: 48%;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.message {
							display: flex;
							align-items: center;
							justify-content: space-between;
						}

						.head {
							width: 59px;
							height: 57px;
							margin-right: 13px;
							position: relative;

							.head_wrap {
								width: 100%;
								height: 100%;
								position: absolute;
								left: 0;
								top: 0;
								z-index: 2;
							}

							.head_img {
								width: 48px;
								height: 48px;
								border-radius: 50%;
								position: absolute;
								left: 4.5px;
								top: 5.5px;
								z-index: 1;
							}
						}

						.user_info {
							display: flex;
							flex-flow: column;
							justify-content: space-between;

							.name {
								color: white;
								font-size: 18px;
							}

							.country {
								display: flex;
								align-items: center;

								.icon {
									width: 20px;
									height: 20px;
									border: 1px solid #FFFFFF;
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-items: center;
									margin-right: 6px;

									img {
										width: 100%;
										border-radius: 50%;
									}
								}

								.test {
									color: white;
									font-size: 16px;
								}
							}
						}

						.go_app {
							width: 40px;
							height: 40px;
							background: url("../../../assets/recharge/go_app.png") no-repeat;
							background-size: 100%;
						}
					}

					.r {
						.head {
							width: 40px;
							height: 40px;
							background: url("../../../assets/recharge/getWechat.png") no-repeat;
							background-size: 100%;
							margin-right: 8px;
						}
					}
				}
			}

			.tip {
				width: 100%;
				margin: 20px 0 0 0;

				img {
					width: 90%;
					float: left;
				}
			}

			.texts {
				text-align: left;
				float: left;

				p {
					color: #ffffff;
					margin-bottom: 20px;

					&:nth-child(1) {
						margin-top: 50px;
					}

					&:nth-child(2) {
						margin-bottom: 42px;
					}
				}
			}
		}

		.right_wrap {
			// background: green;
			margin-bottom: 140px;

			.one-section {
				padding-left: 16px;
				padding-right: 16px;
				margin-top: 70px;

				.title {
					text-align: left;
					color: #f5f6f7;
					font-weight: 600;
					font-size: 20px;
					line-height: 1;
					font-weight: 700;
				}

				.section-main {
					text-align: center;

					.section-temp {
						margin: 16px 0 4px 0px;
						font-size: 20px;
						position: relative;

						.list {
							display: flex;
							align-items: center;
							flex-flow: column;
							justify-content: space-between;
							padding: 8px;
							width: 179px;
							height: 118px;
							background: #eeeeee;
							color: #333333;
							border-radius: 16px;
							// overflow: hidden;

							.first {
								position: absolute;
								top: -11px;
								left: 0px;
								width: 104px;
								height: 24px;
								background: linear-gradient(134deg, #F99634 0%, #FF2794 100%);
								border-radius: 12px 12px 12px 0px;
								display: flex;
								align-items: center;
								padding: 0 6px;
								font-size: 14px;
								font-family: PingFangSC-Medium, PingFang SC;
								font-weight: 500;
								color: #FFFFFF;
								z-index: 999;
								padding: 8px;


								div {
									display: flex;
									justify-content: center;
									align-items: center;
									line-height: 0;
									font-size: 13px;
								}

								>div:nth-child(1) {
									flex: 1;
								}

								>div:nth-child(2) {
									flex: 0;
									margin-left: 3px;
								}

								img {
									width: 12px;
									height: 12px;
								}
							}

							.avatarFrame {
								width: 48px;
								height: 49px;
								position: absolute;
								bottom: 0;
								left: 0;
							}

							.t {
								display: flex;
								margin-top: 8px;
								font-size: 20px;
								align-items: center;

								img {
									width: 20px;
									height: 20px;
									margin-right: 2px;
								}

								.cheap {
									display: inline-block;
									padding: 0 4px;
									font-size: 12px;
									color: red;
									border: 1px solid #ff2794;
									border-radius: 12px;
									// background: url("../../../assets/recharge/kuang.png") no-repeat;
									// background-size: 100%;
									margin-left: 2px;
								}
							}

							.m {
								padding: 0 10px;
								line-height: 28px;
								font-size: 16px;
								color: #ff2794;
								text-decoration: line-through;
							}

							.b {
								font-size: 20px;
								color: #333333;
								margin-bottom: 8px;
							}
						}

						.actives {
							position: relative;

							.bg {
								width: 100%;
								height: 100%;
								position: absolute;
								left: 0;
								top: 0;
							}
						}

						// div {
						//   width: 179px;
						//   height: 96px;
						//   background: #EEEEEE;
						//   color: #333333;
						//   border-radius: 8px;
						//   overflow: hidden;

						//   p {
						//     margin: 0px;
						//     padding: 0px;
						//     line-height: 1;
						//     margin-top: 50%;
						//     transform: translateY(-340%);
						//     font-weight: 700;
						//   }
						// }
					}
				}
			}

			.two-section {
				padding-left: 16px;
				padding-right: 16px;
				margin-top: 40px;
				font-size: 20px;

				.title {
					text-align: left;
					color: #f5f6f7;
					font-weight: 600;
					line-height: 1;
					font-weight: 700;
				}

				.Price_main {
					width: 100%;
					margin-top: 10px;

					.section-temp-div,
					.section-temp-div-ume {
						background: #eeeeee;
						color: #333333;
						border-radius: 8px;
						font-size: 16px;
						height: 58px;
						display: flex;
						align-items: center;
						justify-content: center;
						margin: 4px 3px;

						.actives {
							width: 100%;
							height: 100%;
							background: linear-gradient(to right bottom, #f99634, #ff2794);
							color: #ffffff;
							border-radius: 8px;
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 16px;
						}
					}

					.section-temp-div {
						background: #eeeeee;

						.actives {
							background: linear-gradient(to right bottom, #f99634, #ff2794);
						}
					}

					.section-temp-div-ume {
						background: linear-gradient(135deg,
								#5c35f0 0%,
								#fd4def 100%);

						.actives {
							background: linear-gradient(135deg,
									#5c35f0 0%,
									#fd4def 100%);
						}
					}

					.section-temp-div-ume:last-child>div,
					.section-temp-div:last-child>div {
						width: 100%;
						background: #777479;
						color: #333333;
						border-radius: 8px;
						font-size: 16px;
						padding: 12px 0;
						height: 58px;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}

				.section-main {
					text-align: center;
					margin-top: 16px;

					.section-temp {
						margin: 12px 0 4px 0px;

						div {
							width: 277px;
							height: 64px;
							background: #eeeeee;
							color: #333333;
							border-radius: 8px;
							overflow: hidden;
							line-height: 64px;
							font-weight: 700;
						}

						.actives {
							background: linear-gradient(134deg,
									#f99634 0%,
									#ff2794 100%);
							position: relative;
							color: white;
						}
					}
				}

				.no_select {
					color: #ff2794;
					margin-top: 25px;
					text-align: left;
				}
			}

			.three-section {
				padding-left: 16px;
				padding-right: 16px;
				margin-top: 40px;
				position: relative;
				font-size: 20px;

				.title {
					text-align: left;
					color: #f5f6f7;
					font-weight: 700;
					line-height: 19px;
				}

				.section-main {
					margin-top: 16px;

					.left {
						width: 382px;

						.inputs {
							color: red;
							height: 100%;
							// line-height: 64px;
							border-radius: 8px;
							width: 382px;
						}

						vertical-align: top;
					}

					.right {
						width: 161px;
						height: 64px;
						text-align: center;
						font-weight: 700;
						font-size: 18px;
						margin-left: 20px;
						background: linear-gradient(134deg,
								#f99634 0%,
								#ff2794 100%);
						color: white;
						border-radius: 4px;
					}

					.modules {
						position: fixed;
						left: 0;
						top: 0;
						width: 100vw;
						height: 100vh;
					}
				}

				.tips {
					margin-top: 10px;
					color: #ff2794;
				}
			}

			.four-section {
				width: 80%;
				text-align: left;
				padding-left: 16px;
				padding-right: 16px;
				margin-top: 20px;
				font-size: 16px;
				line-height: 28px;
				color: #f5f6f7;
			}

			.btn_wrap {
				margin-top: 60px;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				.left {
					padding-left: 16px;
					margin-right: 16px;
				}

				.buyBtn {
					border: 0px;
					color: #ffffff;
					font-size: 20px;
					font-weight: 700;
					padding: 0 16px;
					line-height: 54px;
					background: linear-gradient(to right, #f99634, #ff2794);
					border-radius: 4px;
				}

				.noSelect {
					background: #999;
				}
			}

			.select {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				font-size: 12px;
				margin-top: 9px;

				img {
					width: 12px;
					height: 12px;
					margin-right: 8px;
				}

				a {
					color: #FF2794;
					border-bottom: 1px solid #FF2794;
				}
			}
		}
	}

	.more-information {
		color: #ff2794;
		font-size: 14px;
		line-height: 16px;
		float: right;
		margin: 9px 16px 0 0;
	}

	.van-search {
		background-color: none;
	}

	.activesTrue {
		background: linear-gradient(to right bottom,
				#f99634,
				#ff2794) !important;
		color: #ffffff !important;
	}

	.showCheckout {
		z-index: 999;

		.wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		}

		.block {
			width: 30%;
			background-color: #fff;
			color: #333333;
		}

		.close-checkout {
			display: flex;
			justify-content: flex-end;
			padding: 10px 14px 0 0;
		}

		.show-checkout-pop {
			background-color: #fff;
			padding: 15px;

			*,
			*::before,
			*::after {
				box-sizing: border-box;
			}

			html {
				padding: 1rem;
				background-color: #fff;
				font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
					Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
			}

			#payment-form {
				max-width: 31.5rem;
				margin: 0 auto;
			}

			iframe {
				width: 100%;
			}

			.one-liner {
				display: flex;
				flex-direction: column;
			}

			#pay-button {
				border: none;
				border-radius: 3px;
				color: #fff;
				font-weight: 500;
				height: 40px;
				width: 100%;
				background-color: #13395e;
				box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.4);
			}

			#pay-button:active {
				background-color: #0b2a49;
				box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.4);
			}

			#pay-button:hover {
				background-color: #15406b;
				box-shadow: 0 2px 5px 0 rgba(19, 57, 94, 0.4);
			}

			#pay-button:disabled {
				background-color: #697887;
				box-shadow: none;
			}

			#pay-button:not(:disabled) {
				cursor: pointer;
			}

			.card-frame {
				border: solid 1px #13395e;
				border-radius: 3px;
				width: 100%;
				margin-bottom: 8px;
				height: 40px;
				box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.2);
			}

			.card-frame.frame--rendered {
				opacity: 1;
			}

			.card-frame.frame--rendered.frame--focus {
				border: solid 1px #13395e;
				box-shadow: 0 2px 5px 0 rgba(19, 57, 94, 0.15);
			}

			.card-frame.frame--rendered.frame--invalid {
				border: solid 1px #d96830;
				box-shadow: 0 2px 5px 0 rgba(217, 104, 48, 0.15);
			}

			.error-message {
				color: #c9501c;
				font-size: 0.9rem;
				margin: 8px 0 0 1px;
				font-weight: 300;
			}

			.token {
				color: #b35e14;
				font-size: 0.9rem;
				font-family: monospace;
			}

			@media screen and (min-width: 31rem) {
				.one-liner {
					flex-direction: row;
				}

				.card-frame {
					width: 100%;
					margin-bottom: 0;
				}

				#pay-button {
					width: 175px;
					margin-left: 8px;
				}
			}
		}
	}

	.showGoogle {
		.wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		}

		.block {
			width: 327px;
			height: 255px;
			background-color: #fff;
			border-radius: 12px;
			color: #333333;

			h1 {
				color: #ffd400;
				font-size: 24px;
				text-align: center;
				margin-top: 30px;
			}

			p {
				padding: 20px 10px 0px 10px;
				text-align: center;
			}

			img {
				width: 175px;
				height: 48px;
				margin-top: 29px;
				margin-left: 50%;
				transform: translateX(-50%);
			}
		}
	}

	.showError {
		.wrapper {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
		}

		.block {
			width: 327px;
			height: 222px;
			background-color: #fff;
			border-radius: 12px;
			color: #666666;

			h1 {
				color: #333333;
				font-size: 16px;
				text-align: center;
				margin-top: 30px;

				img {
					transform: translateY(15%);
				}
			}

			p {
				padding: 20px 10px 0px 10px;
				text-align: center;
			}

			button {
				width: 128px;
				height: 40px;
				margin-top: 32px;
				margin-left: 50%;
				transform: translateX(-50%);
				border: 0px;
				background: linear-gradient(to right, #f99634, #ff2794);
				color: #ffffff;
				font-size: 16px;
				border-radius: 20px;
			}
		}
	}

	.showsImg {
		position: absolute;
		right: 16%;
		top: 10%;
	}

	.footer {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100vw;
		height: 200px;
		background: #3B324E;
		padding-left: 13%;
		padding-right: 13%;
		z-index: 998;
		padding-top: 12px;

		.footer_top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 30px;

			a {
				border-bottom: 1px solid #fff;
				font-size: 14px;
			}
		}

		.center {
			margin-top: 24px;
			margin-bottom: 12px;
			font-size: 12px;
		}

		.name {
			font-size: 12px;
		}

		.city {
			font-size: 12px;
		}

		.bottom {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 60px;

			.l {
				font-size: 12px;
			}

			img {
				width: 167px;
			}
		}
	}

	.model {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(150, 150, 150, .6);
		z-index: 1000;

		.model_close {
			width: 100%;
			height: 100%;
			position: absolute;
			z-index: 2;
		}

		.form_wrap {
			width: 420px;
			margin: 0 auto;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translateX(-50%) translateY(-50%);
			background: white;
			z-index: 99;

			#place_order {
				width: 400px;
				margin: 0 auto;
				padding-top: 20px;

				.btns {
					width: 128px;
					height: 40px;
					margin-top: 32px;
					margin-left: 50%;
					transform: translateX(-50%);
					border: 0px;
					background: linear-gradient(to right, #f99634, #ff2794);
					color: #ffffff;
					font-size: 16px;
					border-radius: 20px;
					text-align: center;
					margin-bottom: 20px;
					line-height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: 12px;
						height: 12px;
						transform: rotate(0deg);
						animation: identifier 1s infinite linear;
						margin-top: 6px;
						margin-right: 6px;
					}
				}
			}
		}
	}
}

@keyframes identifier {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.tips2 {
	height: 50px;
	font-size: 18px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #FF2794;
	line-height: 25px;
	margin-bottom: 32px;
	margin-top: 12px;
}

.ume_bg {
	background: linear-gradient(135deg, #5C35F0 0%, #FD4DEF 100%) !important;
}

.ume_border {
	// background: url("../../../assets/recharge/ume_kuang.png") no-repeat !important;
	// background-size: 100% !important;
	border:1px solid #5c35f0;
	border-radius: 12px;
	color: #5C35F0 !important;
}

.ume_color {
	color: #5C35F0 !important;
}
</style>
